import React, { forwardRef } from "react";
import "../../../../../styles/print.scss";
import { Col, Row } from 'react-bootstrap';
import brasao from "../../../../../assets/images/brasao.png"
import moment from "moment";

const RequisicaoPrint = forwardRef(({ requisicao }, ref) => {

    const dataCad = moment(requisicao.dataCad).utc(false).format("DD [de] MMMM [de] YYYY")
    return (
        <div ref={ref} className="folha-a4">
            <div className="cabecalho">
                <div className="parte-1">
                    <Row>
                        <Col xs={3}>
                            <img src={brasao} alt="Brasão do RJ" className="brasao-print" />
                        </Col>
                        <Col xs={8}>
                            <div className="titulo">
                                <p className="estado"><strong>ESTADO DO RIO DE JANEIRO</strong></p>
                                <p className="pref-mac">PREFEITURA MUNICIPAL DE MACUCO</p>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="parte-2">
                    <p>Folha n.º _______</p>
                    <p>Proc. n.º _______</p>
                    <p style={{ marginTop: "8px" }}>Rubrica: _____________</p>
                </div>
            </div>

            <div className="info-box">
                <p>Senhor(a) Prefeito(a),</p>
                <p><strong>Nome/Razão Social:</strong> {requisicao.nome}</p>
                <p><strong>Endereço:</strong> {requisicao.endereco}</p>
                <p><strong>Contato/E-mail:</strong> {requisicao.email}</p>
                {requisicao.cidade ? <p><strong>Cidade:</strong> {requisicao.cidade}</p> : null}
                <p><strong>Requer, através do número de requisição {requisicao._id}:</strong></p>
                <p className="descricao">{requisicao.descricao}</p>
            </div>

            <div className="rodape-print">
                <p>Nestes termos pede deferimento.</p>
                <p>Macuco, {dataCad}</p>
            </div>
        </div>
    );
});

export default RequisicaoPrint;